<template>
  <div id="app-wrapper">
    <transition name="fade" mode="in-out">
      <main :class="{ show: !showSplash && !isLoading && !showSubscribeNow }">
        <app-header />
        <keep-alive>
          <router-view v-show="!mobileNav" />
        </keep-alive>
        <pre-order :isActive="preOrderStatus" />
        <!-- <newsletter class="newsletter" v-if="$route.name !== 'order'" /> -->
        <app-footer v-show="!mobileNav" />

        <div
          class="back-to-top"
          :class="{ show: scrollToTop }"
          @click="toTop()"
        >
          <img src="@/assets/img/icon_up.png" class="arrow-up" />
          <span class="desc">
            Back To Top
          </span>
        </div>
      </main>
    </transition>
    <!-- <newsletter-alert /> -->
    <app-alert />
    <loading v-if="isLoading" />
    <splash v-if="showSplash && !isLoading && initialLoad" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppHeader from "./components/layout/AppHeader";
import AppFooter from "./components/layout/AppFooter";
import PreOrder from "./components/PreOrder";
import Loading from "@/components/Loading";
import Splash from "@/components/Splash";
import Newsletter from "@/components/Newsletter";
// import NewsletterAlert from "@/components/NewsletterAlert";
const AppAlert = () => import("@/components/AppAlert");

export default {
  name: "App",
  data() {
    return {
      showSplash: false,
      initialLoad: true,
      mobileNav: false,
      scrollToTop: false
    };
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    isLoading(val) {
      if (!val && this.initialLoad && this.$route.name !== "verification") {
        this.showSplash = true;
        setTimeout(() => {
          this.showSplash = false;
          this.initialLoad = false;
        }, 6000);
      }
    },

    initialLoad() {
      setTimeout(() => {
        this.$store.dispatch("newsletter/toggleAlert", true);
      }, 1000);
    }
  },

  computed: {
    ...mapGetters({
      preOrderStatus: "preOrder/getPreOrderStatus",
      isLoading: "loading/getShowLoading",
      showAlert: "alert/isActive",
      showSubscribeNow: "newsletter/showSubscribeNow"
    })
  },

  methods: {
    handleScroll() {
      if (window.pageYOffset > 500) {
        this.scrollToTop = true;
      } else {
        this.scrollToTop = false;
      }
    },

    toTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  },

  components: {
    AppHeader,
    AppFooter,
    PreOrder,
    AppAlert,
    Loading,
    Splash,
    Newsletter
    // NewsletterAlert
  }
};
</script>

<style lang="scss" scoped>
main {
  position: fixed;
  transition: opacity 0.5s ease;

  &.show {
    position: relative;
  }

  .back-to-top {
    position: fixed;
    right: 15px;
    top: 135px;
    z-index: +99;
    border: none;
    background-color: #002e41;
    border: 3px solid #446876;
    border-radius: 5px;
    color: #91aaaa;
    font-size: 12px;
    padding: 0 5px;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.5s ease-in-out;
    pointer-events: none;

    &.show {
      opacity: 1;
      pointer-events: all;
    }

    .arrow-up {
      display: inline-block;
      width: 20px;
      height: 20px;
    }

    &:hover {
      max-width: 130px;
    }

    .desc {
      display: none;
    }
  }
}

@include desktop {
  main {
    .back-to-top {
      font-size: 14px;
      max-width: 50px;

      .desc {
        display: block;
        position: absolute;
        color: #fff;
        padding: 0 5px;
        opacity: 0;
        font-size: 12px;
      }

      &:hover {
        max-width: auto;

        .desc {
          position: relative;
          opacity: 1;
          transition: 0.3s ease 0.3s;
        }
      }
    }
  }
}
</style>
